import React, { useRef, useEffect } from 'react';
import { X } from 'react-feather';
import ReactHtml from 'components/shared/ReactHtml';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { Text, TEXT_VARIANTS } from 'components/ui/Typography';
import { Button, ButtonGroup, IconButton } from 'ui';

const ConfirmationModal = ({ closeModal, feature, discardAndGenerate }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, []);

  return (
    <RenderInBody>
      <ModalContainer
        onEscape={closeModal}
        className="ModalTakeover-background Modal-background d-f ai-c"
      >
        <div className="LessonRecap ConfirmationModal ModalTakeover-container">
          <div className="ConfirmationModal-content">
            <div className="ConfirmationModal-header d-f jc-sb">
              <Text variant={TEXT_VARIANTS.BODY}>
                {t('common.are_you_sure')}
              </Text>
              <IconButton aria-label={t('common.close')} onClick={closeModal}>
                <X size={20} />
              </IconButton>
            </div>
            <div className="ConfirmationModal-body">
              <Text variant={TEXT_VARIANTS.BODY}>
                {feature === 'summary' && (
                  <ReactHtml>
                    {t('lessons.recap.confirmation_modal.summary_message_html')}
                  </ReactHtml>
                )}
                {feature === 'keyTakeaways' && (
                  <ReactHtml>
                    {t(
                      'lessons.recap.confirmation_modal.key_takeaways_message_html',
                    )}
                  </ReactHtml>
                )}
              </Text>
            </div>
            <div className="ConfirmationModal-divider" />
            <ButtonGroup alignEnd className="ConfirmationModal-footer">
              <Button onClick={closeModal}>{t('common.cancel')}</Button>
              <Button ref={ref} customColor onClick={discardAndGenerate}>
                {t('lessons.recap.confirmation_modal.replace_button')}
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

export default ConfirmationModal;
